// @ts-nocheck
// Admin-only AI support assistant for a single account. Asks questions like
// "why are so few posts going out?" — answered in Hebrew, grounded in live data.
import React, {useRef, useState, useEffect} from 'react'
import {supportChat, getSupportQuickQuestions, saveSupportQuickQuestions} from './core/_requests'

const SupportChat = ({accountId}: {accountId: string}) => {
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState<any[]>([])
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [questions, setQuestions] = useState<string[]>([])
  const [editing, setEditing] = useState(false)
  const [newQ, setNewQ] = useState('')
  const bottomRef = useRef<any>(null)

  useEffect(() => {
    getSupportQuickQuestions().then((r) => setQuestions(r.data?.questions || [])).catch(() => {})
  }, [])

  useEffect(() => {
    bottomRef.current?.scrollIntoView({behavior: 'smooth'})
  }, [messages, loading])

  const persistQuestions = async (next: string[]) => {
    setQuestions(next)
    try { await saveSupportQuickQuestions(next) } catch (_) {}
  }
  const addQuestion = () => {
    const q = newQ.trim()
    if (!q) return
    persistQuestions([...questions, q])
    setNewQ('')
  }
  const removeQuestion = (i: number) => persistQuestions(questions.filter((_, idx) => idx !== i))

  const ask = async (text: string) => {
    const q = (text || '').trim()
    if (!q || loading) return
    const next = [...messages, {role: 'user', content: q}]
    setMessages(next)
    setInput('')
    setLoading(true)
    try {
      const res = await supportChat(accountId, next)
      setMessages([...next, {role: 'assistant', content: res.data?.reply || '—'}])
    } catch (e: any) {
      setMessages([...next, {role: 'assistant', content: 'שגיאה: ' + (e?.response?.data?.error || e?.message)}])
    }
    setLoading(false)
  }

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        title="עוזר תמיכה AI לחשבון זה"
        style={{position: 'fixed', right: 24, bottom: 24, zIndex: 1080, background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: '#fff', border: 'none', borderRadius: 28, padding: '12px 20px', fontWeight: 700, boxShadow: '0 8px 24px rgba(99,102,241,0.4)', cursor: 'pointer'}}
      >
        <i className='bi bi-robot me-2' /> עוזר תמיכה
      </button>
    )
  }

  return (
    <div dir='rtl' style={{position: 'fixed', right: 24, bottom: 24, zIndex: 1080, width: 400, maxWidth: '95vw', height: 560, maxHeight: '85vh', background: '#fff', borderRadius: 16, boxShadow: '0 16px 50px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid #eef0f4'}}>
      <div style={{background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <span style={{fontWeight: 700}}><i className='bi bi-robot me-2' />עוזר תמיכה</span>
        <button onClick={() => setOpen(false)} style={{background: 'transparent', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer'}}>×</button>
      </div>

      <div style={{flex: 1, overflowY: 'auto', padding: 14, background: '#f7f8fa'}}>
        {messages.length === 0 && (
          <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
              <span style={{color: '#7e8299', fontSize: 13}}>שאל שאלה על החשבון. דוגמאות:</span>
              <button onClick={() => setEditing(!editing)} style={{background: 'transparent', border: 'none', color: '#6366f1', fontSize: 12.5, cursor: 'pointer', fontWeight: 600}}>
                {editing ? 'סיום' : '✎ ערוך'}
              </button>
            </div>
            {questions.map((s, i) => (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8}}>
                <button onClick={() => !editing && ask(s)} style={{flex: 1, textAlign: 'start', background: '#fff', border: '1px solid #eef0f4', borderRadius: 10, padding: '9px 12px', cursor: editing ? 'default' : 'pointer', fontSize: 13.5}}>
                  {s}
                </button>
                {editing && (
                  <button onClick={() => removeQuestion(i)} title='מחק' style={{background: '#fff5f8', border: '1px solid #f1416c33', color: '#f1416c', borderRadius: 8, width: 30, height: 30, cursor: 'pointer'}}>×</button>
                )}
              </div>
            ))}
            {editing && (
              <div style={{display: 'flex', gap: 6, marginTop: 6}}>
                <input className='form-control form-control-sm' placeholder='שאלה חדשה…' value={newQ} onChange={(e) => setNewQ(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') addQuestion() }} />
                <button className='btn btn-sm' style={{background: '#6366f1', color: '#fff', whiteSpace: 'nowrap'}} onClick={addQuestion}>+ הוסף</button>
              </div>
            )}
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{display: 'flex', justifyContent: m.role === 'user' ? 'flex-start' : 'flex-end', marginBottom: 10}}>
            <div style={{maxWidth: '85%', padding: '9px 13px', borderRadius: 12, fontSize: 13.5, whiteSpace: 'pre-wrap', lineHeight: 1.5, background: m.role === 'user' ? '#6366f1' : '#fff', color: m.role === 'user' ? '#fff' : '#1e1e2d', border: m.role === 'user' ? 'none' : '1px solid #eef0f4'}}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && <div style={{color: '#7e8299', fontSize: 13, textAlign: 'end'}}><span className='spinner-border spinner-border-sm me-2' />חושב…</div>}
        <div ref={bottomRef} />
      </div>

      <div style={{padding: 10, borderTop: '1px solid #eef0f4', display: 'flex', gap: 8}}>
        <input
          className='form-control form-control-sm'
          placeholder='שאל שאלה…'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') ask(input) }}
          disabled={loading}
        />
        <button className='btn btn-sm' style={{background: '#6366f1', color: '#fff'}} disabled={loading || !input.trim()} onClick={() => ask(input)}>
          שלח
        </button>
      </div>
    </div>
  )
}

export default SupportChat
